// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:63384424-0586-44b8-82fb-c44b6e4b8eb2',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_kCGaKH0I7',
    aws_user_pools_web_client_id: '1dadchdsunndamskl4ehu13gfb',
    oauth: {},
    aws_appsync_graphqlEndpoint: 'https://cobdwr4pfvhyzn3lwqnmntfpgi.appsync-api.eu-west-2.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
}


export default awsmobile
